import { useEffect, useState } from "react";
import api from "@/lib/api";
import CardTile from "@/components/CardTile";
import CaptureDialog from "@/components/CaptureDialog";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export default function Everything() {
  const [cards, setCards] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  const load = async () => {
    setLoading(true);
    try { setCards((await api.get("/cards", { params: q ? { q } : {} })).data); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [q]);
  useEffect(() => {
    const h = () => load();
    window.addEventListener("card:changed", h);
    return () => window.removeEventListener("card:changed", h);
  }, [q]);

  const toggleCheck = async (card, item) => {
    const next = card.checklist.map(c => c.id === item.id ? { ...c, done: !c.done } : c);
    setCards(prev => prev.map(c => c.card_id === card.card_id ? { ...c, checklist: next } : c));
    try { await api.patch(`/cards/${card.card_id}`, { checklist: next }); } catch {}
  };
  const onEdit = (card) => { setEditing(card); setDialogOpen(true); };
  const onDelete = async (card) => {
    if (!window.confirm("Delete this card?")) return;
    await api.delete(`/cards/${card.card_id}`);
    toast.success("Deleted");
    load();
  };

  return (
    <div className="relative min-h-screen">
      <div className="orb orb-orange" style={{ width: 500, height: 500, top: -180, right: -140, opacity: 0.18 }} />
      <div className="px-10 pt-10 pb-6 relative">
        <div className="flex items-baseline justify-between mb-6">
          <h1 className="serif-italic text-5xl md:text-6xl text-white/85">Search CortexBase…</h1>
          <div className="text-sm text-white/40">{cards.length} cards</div>
        </div>
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search titles, notes, tags, links…" data-testid="everything-search" className="bg-white/5 border-white/10 h-12 text-base" />
        <div className="mt-4 h-px bg-white/10" />
      </div>

      <div className="px-10 pb-16 relative">
        {loading ? <div className="text-white/40 mt-20 text-center">Loading…</div>
          : cards.length === 0 ? (
            <div className="mt-24 text-center">
              <div className="serif-italic text-3xl text-white/60">Your mind is quiet.</div>
              <p className="text-white/40 mt-3 text-sm">Use the <span className="text-white/70">+ Capture</span> button to save a note.</p>
            </div>
          ) : (
            <div className="masonry">
              {cards.map(card => (
                <CardTile key={card.card_id} card={card} onToggleCheck={toggleCheck} onEdit={onEdit} onDelete={onDelete} />
              ))}
            </div>
          )}
      </div>
      <CaptureDialog open={dialogOpen} onOpenChange={(o) => { setDialogOpen(o); if (!o) { setEditing(null); load(); } }} editing={editing} onCreated={load} />
    </div>
  );
}
